import request from '@/utils/request'

export function listWkPost(query) {
  return request({
    url: '/wk/wkpost/list',
    method: 'get',
    params: query
  })
}

export function getWkPost(id) {
  return request({
    url: '/wk/wkpost/get?id=' + id,
    method: 'get'
  })
}

export function addWkPost(data) {
  return request({
    url: '/wk/wkpost/add',
    method: 'post',
    data: data
  })
}

export function editWkPost(data) {
  return request({
    url: '/wk/wkpost/edit',
    method: 'post',
    data: data
  })
}

export function delWkPost(ids) {
  return request({
    url: '/wk/wkpost/del',
    method: 'post',
    data: {
      ids: ids
    }
  })
}
